import { render, staticRenderFns } from "./Snitches.vue?vue&type=template&id=a7caa602&"
import script from "./Snitches.vue?vue&type=script&lang=js&"
export * from "./Snitches.vue?vue&type=script&lang=js&"
import style0 from "./Snitches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports